<script lang="ts" setup>
import { ref } from 'vue';

const changes = [
    { version: '2024.09.24.1430', change: 'changelog.v202490241430' },
    { version: '2024.09.24.2011', change: 'changelog.v202490242011' },
    { version: '2024.10.14.2100', change: 'changelog.v202410142100' },
    { version: '2024.10.20.1400', change: 'changelog.v202410201400' },
    { version: '2024.10.22.1222', change: 'changelog.v202410221222' },
    { version: '2024.10.22.1306', change: 'changelog.v202410221306' },
    { version: '2024.11.18.1025', change: 'changelog.v202411181025' },
    { version: '2024.12.27.0930', change: 'changelog.v202412270930' },
    { version: '2024.12.30.1500', change: 'changelog.v202412301500' },
    { version: '2025.01.01.1500', change: 'changelog.v202501071500' },
    { version: '2025.01.08.1250', change: 'changelog.v202501081250' },
    { version: '2025.01.16.1313', change: 'changelog.v202501161313' },
    { version: '2025.01.23.1430', change: 'changelog.v202501321430' },
    { version: '2025.01.29.0944', change: 'changelog.v202501290944' },
    { version: '2025.01.29.1320', change: 'changelog.v202501291320' },
    { version: '2025.03.25.2200', change: 'changelog.v202503252200' },
    { version: '2025.06.02.1400', change: 'changelog.v202506021400' },
    { version: '2025.06.11.1300', change: 'changelog.v202506111300' },
    { version: '2025.08.11.1300', change: 'changelog.v202508111300' },
    { version: '2025.08.26.1000', change: 'changelog.v202508261000' },
    { version: '2025.08.29.1230', change: 'changelog.v202508291230' },
    { version: '2025.09.03.0800', change: 'changelog.v202509030800' },
    { version: '2025.09.22.1100', change: 'changelog.v202509221100' },
    { version: '2025.09.25.2100', change: 'changelog.v202509252100' },
    { version: '2025.09.26.1420', change: 'changelog.v202509261420' },
    { version: '2025.09.30.1230', change: 'changelog.v202509301230' },
    { version: '2025.10.01.1100', change: 'changelog.v202510011100' },
    { version: '2025.10.02.0945', change: 'changelog.v202510020945' },
    { version: '2025.10.03.1150', change: 'changelog.v202510031150' },
    { version: '2025.10.03.1230', change: 'changelog.v202510031230' },
    { version: '2025.10.03.1300', change: 'changelog.v202510031300' },
    { version: '2025.10.09.1400', change: 'changelog.v202510091400' },
    { version: '2025.10.10.1200', change: 'changelog.v202510101200' },
    { version: '2025.10.14.1330', change: 'changelog.v202510141330' },
    { version: '2025.10.16.1100', change: 'changelog.v202510161100' },
    { version: '2025.10.16.1805', change: 'changelog.v202510161805' },
    { version: '2025.10.17.1145', change: 'changelog.v202510171145' },
    { version: '2025.10.17.1455', change: 'changelog.v202510171455' },
    { version: '2025.10.17.1200', change: 'changelog.v202510171200' },
    { version: '2025.10.21.1530', change: 'changelog.v202510211530' },
    { version: '2025.10.29.0800', change: 'changelog.v202510290800' },
    { version: '2025.10.31.1400', change: 'changelog.v202510311400' },
    { version: '2025.11.06.1500', change: 'changelog.v202511061500' },
    { version: '2025.11.10.1330', change: 'changelog.v202511101330' },
    { version: '2025.11.14.1100', change: 'changelog.v202511141100' },
    { version: '2025.11.14.1130', change: 'changelog.v202511141130' },
    { version: '2025.11.21.1111', change: 'changelog.v202511211111' },
    { version: '2025.11.24.0825', change: 'changelog.v202511240825' },
    { version: '2025.11.24.1430', change: 'changelog.v202511241430' },
    { version: '2025.11.24.2000', change: 'changelog.v202511242000' },
    { version: '2025.11.26.1030', change: 'changelog.v202511261030' },
    { version: '2025.11.28.0800', change: 'changelog.v202511280800' },
    { version: '2025.12.01.0800', change: 'changelog.v202512010800' },
    { version: '2025.01.12.0930', change: 'changelog.v202501120930' },
    { version: '2025.12.02.1230', change: 'changelog.v202512021230' },
    { version: '2025.12.03.1300', change: 'changelog.v202512031300' },
    { version: '2025.12.10.1220', change: 'changelog.v202512101220' },
    { version: '2025.12.12.1313', change: 'changelog.v202512121313' },
    { version: '2025.12.16.1130', change: 'changelog.v202512161130' },
    { version: '2025.12.17.1120', change: 'changelog.v202512171120' },
    { version: '2025.12.23.0900', change: 'changelog.v202512230900' },
    { version: '2025.12.29.1150', change: 'changelog.v202512291150' },
    { version: '2026.01.14.0930', change: 'changelog.v202601140930' },
    { version: '2026.01.21.1310', change: 'changelog.v202601211310' },
    { version: '2026.02.16.1000', change: 'changelog.v202602161000' },
    { version: '2025.02.17.1130', change: 'changelog.v202502171130' },
    { version: '2026.02.17.1250', change: 'changelog.v202602171250' },
    { version: '2026.02.27.1120', change: 'changelog.v202602271120' },
    { version: '2026.03.02.1330', change: 'changelog.v202603021330' },
    { version: '2026.03.03.0930', change: 'changelog.v202603030930' },
    { version: '2026.03.03.1400', change: 'changelog.v202603031400' },
    { version: '2026.03.05.1520', change: 'changelog.v202603051520' },
    { version: '2026.03.11.1750', change: 'changelog.v202603111750' },
    { version: '2026.05.22.1400', change: 'changelog.v202605221400' },
    { version: '2026.03.23.1100', change: 'changelog.v202603231100' },
    { version: '2026.03.24.1100', change: 'changelog.v202603241100' },
    { version: '2026.03.27.1445', change: 'changelog.v202603271445' },
    { version: '2026.05.22.1400', change: 'changelog.v202605221400' },
    { version: '2026.05.27.1425', change: 'changelog.v202605271425' },
    { version: '2026.05.28.1000', change: 'changelog.v202605281000' },
    { version: '2026.05.28.1111', change: 'changelog.v202605281111' },
    { version: '2026.05.28.1600', change: 'changelog.v202605281600' },
    { version: '2026.06.03.1220', change: 'changelog.v202606031220' },
    { version: '2026.06.05.1010', change: 'changelog.v202606051010' },
    { version: '2026.06.09.1500', change: 'changelog.v202606091500' },
    { version: '2026.06.09.1310', change: 'changelog.v202606091310' },
    { version: '2026.06.22.1130', change: 'changelog.v202606221130' },
    { version: '2026.06.30.1000', change: 'changelog.v202606301000' },
    { version: '2026.07.07.1350', change: 'changelog.v202607071350' },
    { version: '2026.07.08.1400', change: 'changelog.v202607081400' },
    { version: '2026.07.10.1245', change: 'changelog.v202607101245' },
    { version: '2026.07.27.1510', change: 'changelog.v202607271510' },
    { version: '2026.08.17.1140', change: 'changelog.v202608171140' },
    { version: '2026.08.18.1030', change: 'changelog.v202608181030' },
    { version: '2026.08.24.2100', change: 'changelog.v202608242100' },
    { version: '2026.08.25.1200', change: 'changelog.v202608251200' },
    { version: '2026.09.01.1130', change: 'changelog.v202609011130' },
];

const showAll = ref(false);
</script>
<template>
    <!-- TODO - move to own view if we decide to use this? -->

    <template
        v-for="(c, i) in changes.slice().reverse()"
        :key="c.version"
    >
        <span
            class="fs-5 fw-bold"
            v-if="i < 4 || showAll"
            >{{ c.version }}</span
        >
        <span
            v-if="i < 4 || showAll"
            v-html="$tm(c.change, '', true)"
            class="mb-4"
        ></span>
    </template>

    <div v-if="changes.length > 5">
        <a @click="showAll = !showAll">
            {{ showAll ? $tm('general.less') : $tm('general.all') }}
        </a>
    </div>
</template>
